import { gql } from '@apollo/client';
export const PROGRAM_LEVEL_FIELDS = gql `
  fragment ProgramLevelFragment on ProgramLevel {
    id
    name
    contentId
    isActive
    createdAt
    updatedAt
    content {
      id
      clientId
      contentType
      code
      name
    }
    countries {
      id
      name
      code
    }
  }
`;
export const PROGRAM_LEVELS = gql `
  ${PROGRAM_LEVEL_FIELDS}
  query PROGRAM_LEVELS($spec: ProgramLevelSpec!) {
    programLevels(spec: $spec) {
      total
      page
      pageSize
      items {
        ...ProgramLevelFragment
      }
    }
  }
`;
export const SAVE_PROGRAM_LEVEL = gql `
  mutation SAVE_PROGRAM_LEVEL($input: ProgramLevelInput!) {
    saveProgramLevel(input: $input) {
      success
      messages {
        value
        type
        params
      }
      payload
    }
  }
`;
export const UPDATE_PROGRAM_LEVELS = gql `
  mutation UPDATE_PROGRAM_LEVELS(
    $input: BulkUpdateProgramLevelInput!
    $spec: BulkUpdateProgramLevelSpec!
  ) {
    updateProgramLevels(input: $input, spec: $spec) {
      success
      messages {
        value
        type
        params
      }
      payload
    }
  }
`;
